module.exports = __webpack_public_path__ + "img/doc-interactive.30a94403.png";